import React, { Component } from 'react'
import { withCookies, Cookies } from 'react-cookie'
import OwnerDashboard from './OwnerDashboard'

class DashboardPage extends Component {
    constructor(props) {
        super(props)
    }

    UNSAFE_componentWillMount() {}

    render() {
        return (
            <div className="bashboard_wrap">
                <OwnerDashboard history={this.props.history} />
            </div>
        )
    }
}

export default withCookies(DashboardPage)



// WEBPACK FOOTER //
// ./Src/Containers/Dashboard/DashboardPage.js